module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    attrs: {
      "id": "installation-page"
    }
  }, [_c('app-header', {
    attrs: {
      "icon": "factory"
    }
  }, [_vm._v("\n        Installation\n    ")]), _vm._v(" "), _c('nav', {
    staticClass: "wrap",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    },
    attrs: {
      "id": "actions-top"
    }
  }, [_c('action-bar', {
    attrs: {
      "back": {
        name: 'liste-installations',
        params: {
          id: this.$route.params.id
        }
      }
    }
  }, [(_vm.typeUser === 'technicien') ? _c('router-link', {
    staticClass: "btn add btn-full",
    attrs: {
      "id": "main-action",
      "to": {
        name: 'new-fibsdd',
        query: {
          detenteur: this.$route.params.id,
          installation: this.$route.params.idInst
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('strong', [_vm._v("Intervenir")]), _vm._v(" sur l'installation\n            ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.installation.i_tag !== null || _vm.optionForceOtag === true) ? _c('div', {
    staticClass: "wrap"
  }, [(_vm.installation.fluide !== null) ? _c('router-link', {
    staticClass: "btn btn-full text-btn responsive-scop",
    staticStyle: {
      "background-color": "#EA5E0B"
    },
    attrs: {
      "to": {
        name: 'information-installation'
      }
    }
  }, [_vm._v("Informations complémentaires "), _c('br'), _vm._v(" (DESP, Maintenance préventive, Attestation Entretien)")]) : _c('router-link', {
    staticClass: "btn btn-full text-btn responsive-scop",
    staticStyle: {
      "background-color": "#EA5E0B"
    },
    attrs: {
      "to": {
        name: 'information-installation'
      }
    }
  }, [_vm._v("Informations complémentaires "), _c('br'), _vm._v(" (Maintenance préventive)")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "map",
    staticClass: "hide",
    staticStyle: {
      "height": "210px",
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "wrap",
    attrs: {
      "method": "post",
      "id": "installation"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "idInstall"
    }
  }), _vm._v(" "), (_vm.installation.i_tag !== null) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-content": "center",
      "align-items": "center"
    }
  }, [_c('label', {
    staticStyle: {
      "flex-basis": "content"
    }
  }, [_vm._v("OTAG INSTALL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.i_tag),
      expression: "installation.i_tag",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "flex-basis": "content"
    },
    attrs: {
      "title": "installItag",
      "type": "text",
      "name": "itag",
      "maxlength": "255",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.installation.i_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "i_tag", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full text-btn",
    staticStyle: {
      "background-color": "rgb(234, 94, 11)",
      "flex-basis": "content",
      "padding-right": "20px"
    },
    attrs: {
      "href": "fi360://scan?success=tryGoToInstall&idInst=" + this.$route.params.idInst + "&idDet=" + this.$route.params.id,
      "id": "change-itag"
    }
  }, [_vm._v("Changer l'otag install")])]) : _c('div', [_c('a', {
    staticClass: "btn btn-full text-btn",
    staticStyle: {
      "background-color": "rgb(234, 94, 11)"
    },
    attrs: {
      "href": "fi360://scan?success=tryGoToInstall&idInst=" + this.$route.params.idInst + "&idDet=" + this.$route.params.id,
      "id": "add-itag"
    }
  }, [_vm._v("Ajouter une otag install")])]), _vm._v(" "), _c('label', [_vm._v("Nom de l'installation *")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.nom),
      expression: "installation.nom",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "installName",
      "type": "text",
      "name": "nom",
      "id": "nom",
      "maxlength": "255",
      "value": ""
    },
    domProps: {
      "value": (_vm.installation.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "nom", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.optionBarcode === true) ? _c('a', {
    staticClass: "btn btn-full",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "href": "fi360://scan?success=fillCodeBarre&type=installation",
      "id": "barcode-scan"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "0 20px",
      "height": "35px"
    },
    attrs: {
      "src": require("../../img/barcode-scan.png")
    }
  })]) : _vm._e()]), _vm._v(" "), _c('label', [_vm._v("Marque "), (!_vm.gotFluide) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.marque),
      expression: "installation.marque",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "marque",
      "type": "text",
      "name": "nom",
      "id": "marque",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.marque)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "marque", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Modèle / N° de série / Repère "), (!_vm.gotFluide) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.modele),
      expression: "installation.modele",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "model",
      "type": "text",
      "name": "nom",
      "id": "modele",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.modele)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "modele", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Commentaire")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.installation.commentaire),
      expression: "installation.commentaire",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "title": "commentaire",
      "type": "text",
      "name": "commentaire",
      "id": "commentaire",
      "value": "",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.installation.commentaire)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "commentaire", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._l((_vm.photoSlots), function(slot) {
    return _c('div', {
      key: slot.field
    }, [_c('a', {
      staticClass: "btn btn-full photo",
      attrs: {
        "href": "javascript: void 0"
      },
      on: {
        "click": function($event) {
          _vm.$refs['photo_' + slot.field][0].click()
        }
      }
    }, [_vm._v("\n                " + _vm._s(slot.label) + "\n                "), _c('i', {
      staticClass: "icon-photo"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      ref: 'photo_' + slot.field,
      refInFor: true,
      attrs: {
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.handlePhotoInstall($event, slot.field)
        }
      }
    }), _vm._v(" "), (_vm.getUrlPhoto(slot.field) !== null) ? _c('div', {
      staticClass: "preview-img"
    }, [_c('i', {
      staticClass: "icon icon-delete",
      on: {
        "click": function($event) {
          return _vm.dropPhoto(slot.field)
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.getUrlPhoto(slot.field),
        "title": "photo de l'installation",
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "photo-install",
      attrs: {
        "src": _vm.getUrlPhoto(slot.field),
        "alt": "photo installation"
      }
    })])]) : _vm._e()])
  }), _vm._v(" "), (_vm.gotFluide) ? _c('div', [_c('label', [_vm._v("Type de fluide *")]), _vm._v(" "), (_vm.installation.fluide) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.fluide),
      expression: "installation.fluide"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "fluide", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateComputed]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Sélectionnez un fluide *")]), _vm._v(" "), _vm._l((_vm.fluides), function(fluide) {
    return _c('option', {
      key: fluide.id,
      domProps: {
        "value": fluide
      }
    }, [_vm._v(_vm._s(fluide.nom) + _vm._s((fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : '') + "\n                ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Charge totale (Kg) *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.installation.charge),
      expression: "installation.charge",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "title": "chargeTotal",
      "type": "number",
      "name": "charge_totale",
      "min": "0.010",
      "step": "0.001",
      "id": "charge_totale"
    },
    domProps: {
      "value": (_vm.installation.charge)
    },
    on: {
      "change": _vm.updateComputed,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.installation, "charge", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Détecteur de fuite fixe *")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    attrs: {
      "name": "detecteur_fuite_fixe",
      "id": "fuite_ok",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.detecteur, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "fuite_ok"
    }
  }, [_vm._v("\n                    Oui\n                    "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.detecteur),
      expression: "installation.detecteur"
    }],
    attrs: {
      "name": "detecteur_fuite_fixe",
      "id": "fuite_ko",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.detecteur, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "detecteur", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "fuite_ko"
    }
  }, [_vm._v("\n                    Non\n                    "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.canForceFrequence === true) ? _c('div', [_c('label', [_vm._v("Fréquence de contrôle forcée")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    attrs: {
      "name": "force_frequence",
      "id": "force_frequence",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installation.force_frequence, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", true)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "force_frequence"
    }
  }, [_vm._v("\n                        Oui\n                        "), _c('i', {
    staticClass: "icon-valid"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.force_frequence),
      expression: "installation.force_frequence"
    }],
    attrs: {
      "name": "force_frequence",
      "id": "force_frequence_no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installation.force_frequence, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.installation, "force_frequence", false)
      }, _vm.updateComputed]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-radio",
    attrs: {
      "for": "force_frequence_no"
    }
  }, [_vm._v("\n                        Non\n                        "), _c('i', {
    staticClass: "icon-valid"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.installation.force_frequence === true) ? _c('div', [_c('label', [_vm._v("Fréquence de contrôle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installation.frequence_controle),
      expression: "installation.frequence_controle"
    }],
    attrs: {
      "name": "frequence_controle",
      "id": "frequence_controle"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.installation, "frequence_controle", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12 mois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24 mois")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fluideIsFibsdd),
      expression: "fluideIsFibsdd"
    }]
  }, [(_vm.installation.fluide !== null && _vm.installation.fluide.type !== 'HFO') ? _c('p', [_vm._v("\n                    Tonnage équivalent CO"), _c('span', {
    staticClass: "smallexp"
  }, [_vm._v("2")]), _vm._v(" :\n                    "), _c('span', {
    attrs: {
      "id": "tonnage"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.tonnage)
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n                    GWP :\n                    "), _c('span', {
    attrs: {
      "id": "gwp"
    },
    domProps: {
      "textContent": _vm._s(_vm.installation.fluide.gwp)
    }
  })]), _vm._v(" "), (_vm.installation.fluide && _vm.installation.fluide.type !== 'CFC') ? _c('p', [_vm._v("\n                    Fréquence de contrôle "), (_vm.installation.force_frequence === true) ? _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("forcée")]) : _vm._e(), _vm._v(" de l'installation :\n                    "), _c('span', {
    attrs: {
      "id": "frequence"
    }
  }, [_vm._v(_vm._s(_vm.installation.frequence_controle === 0 || _vm.installation.frequence_controle == null ? 'Aucune' : _vm.installation.frequence_controle + ' Mois'))])]) : _vm._e(), _vm._v(" "), (_vm.installation.file_notice && _vm.installation.file_notice !== null) ? _c('p', [_vm._v("\n                    Notice de l'installation : "), _c('a', {
    staticClass: "btn-full btn photo",
    staticStyle: {
      "width": "25%",
      "margin-left": "10px",
      "display": "inline-flex"
    },
    attrs: {
      "target": "_blank",
      "href": _vm.getUrlNotice
    }
  }, [_c('i', {
    staticClass: "fas fa-file-alt"
  }), _vm._v(" Voir")])]) : _vm._e(), _vm._v(" "), (_vm.installation.last_control != null) ? _c('p', [_vm._v("\n                    Date du dernier contrôle périodique :\n                    "), _c('span', {
    attrs: {
      "id": "dateLastControl"
    }
  }, [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.installation.last_control, 'DD/MM/YYYY')))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.canEditInstallations) ? _c('input', {
    attrs: {
      "type": "submit",
      "id": "submit-install",
      "name": "new",
      "value": "SAUVEGARDER"
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.fis.length !== 0) ? _c('section', {
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_c('hr'), _vm._v(" "), _c('h2', [_c('strong', [_vm._v("REGISTRE DES INTERVENTIONS")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "interventions-list",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, _vm._l((_vm.fis.slice().reverse()), function(fi) {
    return _c('li', {
      key: fi.id,
      staticClass: "intervention-item"
    }, [(fi.isFibsdd === true) ? [_vm._v("\n                    " + _vm._s(fi.dateToShow) + " -\n                    "), _c('a', {
      attrs: {
        "href": ((_vm.Config.urlAdmin) + "/pdf/fiche/" + (fi.id) + "?token=" + _vm.token),
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(fi.numero) + "\n                    ")]), _vm._v(" "), (fi.intervention_controle_p === true) ? _c('small', [_vm._v(" - Contrôle périodique ")]) : _vm._e()] : [_vm._v("\n                    " + _vm._s(fi.dateToShow) + " -\n                    "), _c('a', {
      attrs: {
        "href": ((_vm.Config.urlAdmin) + "/pdf/externalFile/" + (fi.id) + "?token=" + _vm.token),
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(fi.name) + "\n                    ")])]], 2)
  }), 0)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c9f860","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/Installation.vue
// module id = 739
// module chunks = 0